export default {
  "common": {
    "ok": "确定",
    "language": "语言",
    "languageLoadFailed": "当前语言资源加载失败，已为你切换到简体中文",
    "search": "搜 索",
    "reset": "重 置",
    "cancel": "取 消",
    "confirm": "确 定",
    "close": "关 闭",
    "loading": "正在加载中",
    "to": "至",
    "all": "所有",
    "selectAll": "全选",
    "exportExcel": "导出Excel",
    "exportReport": "导出报表",
    "exportDetail": "导出明细表",
    "dateStart": "日期开始",
    "dateEnd": "日期结束",
    "today": "今天",
    "recentPrefix": "最近：",
    "oneMonth": "1个月",
    "finance": "财务",
    "type": "类型",
    "time": "时间",
    "remark": "备注",
    "operator": "操作员",
    "account": "账号",
    "status": "状态",
    "amount": "金额",
    "orderNo": "订单号",
    "selectDate": "请选择日期",
    "exportProcessing": "文件处理中，请到【下载中心】查看处理结果",
    "paySuccess": "支付成功",
    "payFailed": "支付失败",
    "income": "收入",
    "expense": "支出",
    "incomeExpenseType": "收支类型",
    "rechargeMethod": "充值方式",
    "serialNo": "流水号",
    "transactionNo": "交易单号",
    "rechargeAccount": "充值账号",
    "rechargeAmount": "充值金额",
    "passportNo": "护照号",
    "name": "姓名",
    "category": "分类",
    "visaRegion": "签证地区",
    "visaType": "签证类型",
    "couponChange": "点券变动",
    "couponBalance": "点券余额",
    "countryVisaType": "国家/签证类型",
    "namePassport": "姓名/护照号",
    "couponUnit": "点券",
    "yuan": "元",
    "requestLoading": "正在请求数据",
    "dateRangeTo": "到",
    "operatorStaff": "操作人员",
    "amountWithYuan": "金额(元)",
    "balanceWithYuan": "余额(元)",
    "inputPlaceholder": "请输入",
    "confirmModify": "确认修改",
    "enterNumber": "请输入数字",
    "enterPositiveNumber": "请输入大于0的数字"
  },
  "nav": {
    "visaTools": "签证工具",
    "insurance": "保险",
    "visaService": "签证服务",
    "fliggyOrders": "飞猪订单",
    "wangdan": "旺单",
    "shanfu": "闪付",
    "overseasTravel": "海外旅游采购",
    "downloadCenter": "下载中心",
    "accountMgmt": "账号管理",
    "finance": "财务",
    "freeLogin": "免登",
    "couponAccount": "点券账户(签证工具使用费)",
    "shanfuAccount": "闪付(签证费代付)",
    "insuranceAccount": "保险账户(用于买保险)",
    "recharge": "充值",
    "accountDetail": "账户明细",
    "couponUnit": "点券",
    "yuan": "元",
    "bindMobile": "绑定手机号",
    "editPassword": "修改密码",
    "logout": "退出登录",
    "acquiring": "收单易"
  },
  "platform": {
    "couponAccountLabel": "点券账户(签证工具使用服务费)",
    "mallAccountLabel": "现金账户(俄罗斯签证费)",
    "wangdanIntroAlt": "旺单介绍"
  },
  "financial": {
    "sidebar": {
      "rechargeCenter": "充值中心",
      "couponDetail": "点券明细",
      "mallAccount": "现金账户",
      "usa": "美国",
      "malay": "马来西亚",
      "visaFeeAccount": "签证费账户"
    },
    "breadcrumb": {
      "couponDetail": "点券明细",
      "cashAccount": "现金账户",
      "usaAccount": "美国签证费账户",
      "malayAccount": "马来西亚签证费账户"
    },
    "tabs": {
      "recharge": "充值",
      "expenditure": "支出"
    },
    "payment": {
      "payMethod": "支付方式",
      "scanPay": "扫码支付",
      "bankTransfer": "银行转账",
      "scanHint": "请使用 支付宝 / 微信 扫码支付",
      "accountNo": "账号",
      "accountName": "开户名",
      "bankName": "开户行",
      "bankAccountName": "浙江保牛信息科技有限公司",
      "bankBranch": "招商银行杭州城西支行",
      "rechargeSuccess": "充值成功",
      "continueRecharge": "继续充值",
      "viewRecords": "查看充值记录",
      "payable": "应付金额",
      "inputAmount": "请输入金额",
      "back": "返回",
      "rechargeNow": "立即充值",
      "alipayPay": "支付宝支付",
      "scanToPay": "扫码付款",
      "cancelPay": "取消付款",
      "confirmPaid": "确认已付款",
      "noScanInfo": "暂无扫码信息！"
    },
    "recharge": {
      "selectAmountTitle": "请选择点券充值金额",
      "selectAmountDesc": "点券用于支付使用签证工具的服务费，充值后无法提现或退款",
      "couponBalance": "点券账户余额",
      "rateHint": "1点券 = 1元",
      "cashInputTitle": "请输入现金充值金额",
      "cashInputDesc": "现金用于办签时使领馆收取的签证费用",
      "cashBalance": "现金账户余额",
      "cashAccountDesc": "现金账户用于办签时使领馆收取的签证费用",
      "mallBalanceDesc": "(现金账户用于办签时使领馆收取的签证费用)",
      "couponBalanceLabel": "点券余额",
      "couponRechargeTitle": "点券充值",
      "offlineNoticePrimary": "暂不支持在线充值，请联系与您对接的商务经理充值",
      "offlineNoticeSecondary": "如商务经理无法联系，请联系客服处理（请在9:00 - 21:00 联系）",
      "servicePhone": "客服电话",
      "serviceWechat": "客服微信",
      "servicePhoneNo": "0571-87670963"
    },
    "coupon": {
      "summaryConsume": "共消耗 {n} 点券",
      "summaryRecharge": "共充值 {n} 点券",
      "orderType": "下单类型",
      "summarySeparator": "｜"
    },
    "mall": {
      "balanceTitle": "现金账户余额",
      "rechargeTitle": "现金账户充值",
      "accountBalance": "帐户余额",
      "rechargeAmountLabel": "充值金额",
      "rechargeAmountRequired": "请输入充值金额",
      "rechargeAmountPlaceholder": "请输入您要充值的金额",
      "scanPaySupport": "支持支付宝、微信",
      "notRecharged": "您未充值，请重新扫码支付",
      "iHaveRecharged": "我已充值",
      "rechargeFailed": "充值失败，请稍后再试",
      "rechargeCancelled": "充值已取消，请重试",
      "qrcodeAlt": "支付二维码",
      "amountMustNumber": "充值金额必须为数字",
      "amountMustPositive": "充值金额必须大于0"
    },
    "usa": {
      "cgiNo": "CGI号",
      "receiptNo": "收据号",
      "spendAmount": "支出金额",
      "customerName": "客户姓名",
      "payTime": "支付时间"
    },
    "malay": {},
    "dialog": {
      "selectRechargeItem": "请选择充值项",
      "couponFor": "点券可用于：",
      "applyVisa": "办理签证",
      "useVisaTool": "使用签证工具",
      "usaExpedited": "美签加急预约",
      "accountLabel": "账号：",
      "lybAccount": "7497 7132 5301",
      "lybAccountName": "深圳市旅云保科技有限公司",
      "lybBankBranch": "开户行：中国银行深圳分行福田支行",
      "defaultAccount": "5719 1190 2610 901",
      "notice1": "1、点券用于支付使用闪电签平台签证工具服务的增值服务费",
      "notice2": "2、充值成功即表示闪电签平台服务已开始",
      "notice3": "3、点券余额为虚拟币，充值后无法提现或退款，请确认后再充值",
      "listApplyVisa": "1、办理签证",
      "listUseVisaTool": "2、使用签证工具",
      "listUsaExpedited": "3、美签加急预约",
      "ticketRecharge": "点券充值",
      "rateResolve": "1元=1点券",
      "rechargeChoice": "充值选择：",
      "payableAmount": "应付金额：",
      "rechargeMethod": "充值方式：",
      "payNow": "立即支付",
      "alipayOnly": "暂时只支持支付宝支付",
      "visaFeeOnlineRecharge": "签证费在线充值",
      "step1": "第一步：",
      "step2": "第二步：",
      "step3": "第三步：",
      "alipayScan": "支付宝扫码",
      "fillRemark": "填写备注",
      "autoCredit": "自动到账",
      "alipayScanAlt": "支付宝扫码",
      "fillRemarkAlt": "填写备注",
      "autoCreditAlt": "自动到账",
      "scanPayHint": "点击下方「扫码付款」后打开支付宝扫码支付",
      "remarkHintLyb": "在备注内输入「旅-充值账号」即可，为防止误充或充值失败，请勿填写额外内容",
      "remarkHintDefault": "在备注内输入需充值的账号即可，为防止误充或充值失败，请勿填写额外内容",
      "remark": "备注",
      "autoCreditHint": "付款成功后点击「确认已付款」，充值金额将在2小时内自动到账",
      "accountRechargeTitle": "帐户充值",
      "accountBalanceLabel": "帐户余额：",
      "rechargeAmountColon": "充值金额："
    }
  },
  "message": {
    "list": {
      "title": "消息中心",
      "all": "全部",
      "submitFailure": "提交失败",
      "unpaidMoney": "待支付领馆费用",
      "comeVisa": "出签",
      "rejectVisa": "拒签",
      "notification": "消息通知"
    },
    "common": {
      "viewDetail": "查看详情",
      "noData": "暂无消息"
    },
    "submitFailure": {
      "empty": "暂无待提交失败消息息",
      "title": "提交失败消息通知"
    },
    "unpaidMoney": {
      "empty": "暂无待支付领馆费用消息",
      "title": "待支付领馆费用消息通知"
    },
    "comeVisa": {
      "empty": "暂无出签消息",
      "title": "出签消息通知",
      "viewButton": "出签消息通知"
    },
    "rejectVisa": {
      "empty": "暂无拒签消息",
      "title": "拒签消息通知"
    }
  },
  "account": {
    "password": {
      "title": "修改密码",
      "oldPassword": "原密码",
      "newPassword": "新密码",
      "confirmPassword": "确认密码",
      "oldRequired": "请输入原密码",
      "newRequired": "请输入新密码",
      "confirmRequired": "请确认新密码",
      "mismatch": "两次输入密码不一致",
      "success": "密码修改成功",
      "legacyOld": "旧密码",
      "legacyNew": "新密码",
      "oldEmpty": "旧密码不能为空",
      "newEmpty": "新密码不能为空",
      "patternOld": "请输入6-16个字符，可以是纯数字或者纯英文",
      "patternNew": "请输入8-16位字符，必须是字母加数字的组合",
      "samePassword": "新旧密码不能相同",
      "modifySuccess": "修改密码成功"
    }
  }
};
